import { render, staticRenderFns } from "./FormEncuestaServicio.vue?vue&type=template&id=2bb86f60&scoped=true"
import script from "./FormEncuestaServicio.vue?vue&type=script&lang=ts"
export * from "./FormEncuestaServicio.vue?vue&type=script&lang=ts"
import style0 from "./FormEncuestaServicio.vue?vue&type=style&index=0&id=2bb86f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb86f60",
  null
  
)

export default component.exports